<template>
    <MainContent title="Listado de eventos">
        <template v-slot:header>
            <div class="mb-3 mr-1 mr-md-0 d-flex flex-md-row flex-column">
                <Button class="ml-2 " :class="tab == 'actuales' ? 'bg-info' : ''" @click.prevent="tab = 'actuales'">Eventos actuales</Button>
                <Button class="ml-2 mt-2 mt-md-0" :class="tab == 'pasados' ? 'bg-info' : ''" @click.prevent="tab = 'pasados'">Eventos pasados</Button>
                <Button
                    class="ml-2 mt-2 mt-md-0" :class="tab == 'resumen_ventas' ? 'bg-info' : ''"
                    @click.prevent="tab = 'resumen_ventas'"
                    v-if="permisos['taquilleros.gestion']"
                >
                    Resumen de ventas
                </Button>
            </div>
        </template>
        <template v-slot:content>
            <transition name="fade" mode="out-in">
                <div key="1" class="overlay-wrapper" v-if="tab == 'actuales'">
                    <EventosActuales/>
                </div>
                <div key="2" class="overlay-wrapper" v-if="tab == 'pasados'">
                    <EventosPasados/>
                </div>
                <div key="3" class="overlay-wrapper" v-if="tab == 'resumen_ventas'">
                    <ResumenVentas/>
                </div>
            </transition>
        </template>
    </MainContent>
</template>

<script>
    import EventosActuales from '@/modules/admin/eventos/EventosActuales.vue';
    import EventosPasados from '@/components/backend/eventos/EventosPasados';
    import ResumenVentas from '@/components/backend/eventos/ResumenVentas';
    import MainContent from "@/components/backend/components/MainContent";

    export default {
        data() {
            return {
                tab: 'actuales'
            }
        },
        computed: {
            permisos() {
                return this.$store.getters.getPermisos;
            }
        },
        components: {
            EventosActuales, EventosPasados, MainContent, ResumenVentas
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>

<style scoped>
    @media (max-width: 768px) {
        .ml-3 {
            margin-bottom: 5px;
            margin-top: 5px;
            float: left;
        }
    }
</style>
